module.exports = __webpack_public_path__ + "assets/b57fced35e9d2df281dbe2dba37b99ef.png";